"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackAddressType = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackAddressType(event_label, selected_address) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickButton,
        click_element: event_label,
        click_text: 'Firma',
        selected_address,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.AddressType,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: 'Firma',
        eventData,
    });
}
exports.trackAddressType = trackAddressType;
//# sourceMappingURL=trackAddressType.js.map